import { type Ref } from 'vue';
import { LoadingStatus } from '@itinerary/ItineraryModuleTypes';
import { type HotelPathData } from '@utils/hotel';
import { type HotelSearchForm } from '@search/hotel/HotelSearchForm';
import type HotelModule from '@itinerary/hotel/HotelModule';

export function usePrefetch(pathData: Ref<HotelPathData>, path: string) {
    const invoiceStore = useInvoiceStore();
    const itineraryStore = useItineraryStore();
    const currentModule = useCurrentItineraryModule<HotelModule>();
    const { currentLoadingStatus } = moduleToRefs(currentModule.value);
    const searchFormStore = useSearchFormStore();
    const { reserveType } = storeToRefs(searchFormStore);
    const formStore = useFormStore();
    const packageSelectStore = usePackageSelectStore();
    const authStore = useAuthStore();
    const priceTrackStore = usePriceTrackStore();
    return async () => {
        if (!currentModule.value.hasItinerarySets) {
            formStore.itineraryPackages = [];
            itineraryStore.currentSetIndex = 0;
        }
        const params = await searchFormStore.loadViewPath(path, pathData.value);
        packageSelectStore.clearSelectedPackages();
        const currentSearchForm = useCurrentSearchForm<HotelSearchForm>();
        itineraryStore.initItineraryModule(params);
        if (currentLoadingStatus.value !== LoadingStatus.Loading) {
            await itineraryStore.loadAvailable();
        }

        if (authStore.loggedIn) {
            priceTrackStore.loadPriceTracks();
        }
        formStore.setCounts({
            adultCount: currentSearchForm.value.adultCount,
            childCount: currentSearchForm.value.childCount,
            infantCount: currentSearchForm.value.infantCount,
        });
        if (!searchFormStore.firstReserveType) {
            searchFormStore.firstReserveType = reserveType.value;
        }
        invoiceStore.priceChangeMessageShown = false;
    };
}
